import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner"]
  static values = { delay: { type: Number, default: 200 } }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.showSpinner()
      this.element.requestSubmit()
    }, this.delayValue)
  }

  showSpinner() {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
